//  import "./App.css";
// import {
//   BrowserRouter,
//   Routes,
//   Route,
// } from "react-router-dom";

// import LoginScreen from "./Screens/Login";
// import VisitDashboard from "./Screens/VisitDashboard";
// import FeedbackScreen from "./Screens/FeedbackScreen";
// import UserCentralFeed from "./Screens/UserCentralFeed";
// import MerchantLoyaltyRules from "./Screens/MerchantLoyaltyRules";
// import MerchantFeedbackLog from "./Screens/MerchantFeedbackLog";
// function App() {
//   return (
//     <BrowserRouter>

//       <Routes>

//         {/* LOGIN SCREEN */}
//         <Route
//           path="/"
//           element={<MerchantFeedbackLog/>}
//         />

//         {/* DASHBOARD */}
//         <Route
//           path="/dashboard"
//           element={<VisitDashboard />}
//         />

//       </Routes>

//     </BrowserRouter>
//   );
// }

// export default App;




// import "./App.css";

// import {
//   BrowserRouter,
//  Routes,
//   Route,
//   Navigate
// } from "react-router-dom";

// /* Protected Routes */
// import ProtectedRoute from "./Screens/ProtectedRoute";
// import MerchantProtectedRoute from "./Screens/MerchantProtectedRoute";

// /* Customer */
// import LoginScreen from "./Screens/Login";
// import VisitDashboard from "./Screens/VisitDashboard";
// import FeedbackScreen from "./Screens/FeedbackScreen";
// import UserCentralFeed from "./Screens/UserCentralFeed";
// import MerchantQRScreen from "./Screens/Merchenqr";
// import MyRestaurantsScreen from "./Screens/MyRestaurantsScreen";
// import MyQRScreen from "./Screens/CustomerQr";

// /* Merchant */
// import MerchantAuth from "./Screens/MerchantAuth";
// import MerchantSubscriptionPanel from "./Screens/Buysubscrption";
// import MerchantLoyaltyRules from "./Screens/MerchantLoyaltyRules";
// import MerchantFeedbackLog from "./Screens/MerchantFeedbackLog";
// import MerchantScannerScreen from "./Screens/Scanqrshop";
// import MerchantScanner from "./Screens/MerchantScanner";

// /* Common */
// import WelcomeGateway from "./Screens/WelcomeGateway";
// import AdvancedOwnerDashboard from "./Screens/Owner";
// function App() {

//   const customerLoggedIn =
//     localStorage.getItem("isLoggedIn") === "true";

//   const merchantLoggedIn =
//     localStorage.getItem("merchantLoggedIn") === "true";

//   return (

//     <BrowserRouter>

//       <Routes>

//         {/* =======================
//             HOME
//         ======================== */}

//         <Route
//           path="/"
//           element={<WelcomeGateway />}
//         />



//         {/* =======================
//             CUSTOMER LOGIN
//         ======================== */}

//         <Route
//           path="/login"
//           element={
//             customerLoggedIn
//               ? <Navigate to="/visit-dashboard" replace />
//               : <LoginScreen />
//           }
//         />



//         {/* =======================
//             MERCHANT LOGIN
//         ======================== */}

//         <Route
//           path="/merchant-login"
//           element={
//             merchantLoggedIn
//               ? <Navigate to="/merchantrules" replace />
//               : <MerchantAuth />
//           }
//         />



//         {/* =======================
//             CUSTOMER ROUTES
//         ======================== */}

//         <Route
//           path="/visit-dashboard"
//           element={
//             <ProtectedRoute>
//               <VisitDashboard />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/feedback"
//           element={
//             <ProtectedRoute>
//               <FeedbackScreen />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/my-feed"
//           element={
//             <ProtectedRoute>
//               <UserCentralFeed />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/my-restaurants"
//           element={
//             <ProtectedRoute>
//               <MyRestaurantsScreen />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/MerchantQRScreen"
//           element={
//             <ProtectedRoute>
//               <MerchantQRScreen />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/MyQRScreen"
//           element={
//             <ProtectedRoute>
//               <MyQRScreen />
//             </ProtectedRoute>
//           }
//         />



//         {/* =======================
//             MERCHANT ROUTES
//         ======================== */}

//         <Route
//           path="/merchantrules"
//           element={
//             <MerchantProtectedRoute>
//               <MerchantLoyaltyRules />
//             </MerchantProtectedRoute>
//           }
//         />

//         <Route
//           path="/merchantanalytics"
//           element={
//             <MerchantProtectedRoute>
//               <MerchantFeedbackLog />
//             </MerchantProtectedRoute>
//           }
//         />

//         <Route
//           path="/MerchantScannerScreen"
//           element={
//             <MerchantProtectedRoute>
//               <MerchantScannerScreen />
//             </MerchantProtectedRoute>
//           }
//         />

//         <Route
//           path="/MerchantScanner"
//           element={
//             <MerchantProtectedRoute>
//               <MerchantScanner />
//             </MerchantProtectedRoute>
//           }
//         />

//         <Route
//           path="/MerchantSubs"
//           element={
//             <MerchantProtectedRoute>
//               <MerchantSubscriptionPanel />
//             </MerchantProtectedRoute>
//           }
//         />



//         {/* =======================
//             INVALID URL
//         ======================== */}

//         <Route
//           path="*"
//           element={<Navigate to="/" replace />}
//         />

//       </Routes>

//     </BrowserRouter>

//   );

// }

// export default App;






//

//

//

//

//

//
import "./App.css";

import {
  BrowserRouter, Routes, Route,
  Navigate,
} from "react-router-dom";

/* CUSTOMER SCREENS */


import LoginScreen from "./Authscreens/Login";
import VisitDashboard from "./Customerscreen/CustomerDash";
import FeedbackScreen from "./MerchentScreens/FeedbackScreen";
import UserCentralFeed from "./Customerscreen/Demo";

import MyRestaurantsScreen from "./MerchentScreens/MyRestaurantsScreen";
 
import MerchantAuth from "./Authscreens/MerchantAuth";
import WelcomeGateway from "./Authscreens/WelcomeGateway";
import MerchantSubscriptionPanel from "./MerchentScreens/Buysubscrption";
import MerchantAuthPremium from "./Authscreens/MerchentSignup";
/* MERCHANT ADMIN */
import MerchantLoyaltyRules from "./Customerscreen/MerchantLoyaltyRules";
import MerchantFeedbackLog from "./Customerscreen/MerchantFeedbackLog";
import MerchantScannerScreen from "./MerchentScreens/Scanqrshop";
import MyQRScreen from "./Customerscreen/CustomerQr";
import OwnerDashboard from "./Authscreens/Owner";
import MerchantScanner from "./Customerscreen/MerchantScanner";
import SplashScreen from "./Authscreens/Splesh";
import MerchantQRScreen from "./Customerscreen/Merchenqr";
 
function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* =========================
            CUSTOMER FLOW
        ========================= */}

        {/* QR SCAN LOGIN */}
        {/* <Route
          path="/"
          element={<OwnerDashboard/>}
        /> */}
        {/* <Route
          path="/"
          element={<LoginScreen />}
        /> */}

        {/* ACTIVE VISIT DASHBOARD */}
        <Route
          path="/"
          element={<SplashScreen/>}
        />
          {/* <Route
          path="/"
          element={<MerchantAuthPremium/>}
        /> */}
         
        <Route
          path="/WelcomeGateway"
          element={<WelcomeGateway />}
        />
         

         
         <Route
          path="/MyQRScreen"
          element={<MyQRScreen />}
        />


        <Route
          path="/MerchantScannerScreen"
          element={<MerchantScannerScreen />}
        />
        <Route
          path="/MerchantScanner"
          element={<MerchantScanner />}
        />

        <Route
          path="/MerchantAuth"
          element={<MerchantAuth />}
        />
        <Route
          path="/MerchantSubs"
          element={<MerchantSubscriptionPanel />}
        />

        <Route
          path="/visit-dashboard"
          element={<VisitDashboard />}
        />
                 
        <Route
          path="/Login"
          element={<LoginScreen />}
        />
        <Route
          path="/my-restaurants"
          element={<MyRestaurantsScreen />}
        />
        <Route
          path="/MerchantQRScreen"
          element={<MerchantQRScreen />}
        />
        {/* FEEDBACK SCREEN */}
        <Route
          path="/feedback"
          element={<FeedbackScreen />}
        />

        {/* USER CENTRAL FEED */}
        <Route
          path="/my-feed"
          element={<UserCentralFeed />}
        />



        {/* =========================
            MERCHANT ADMIN PANEL
        ========================= */}

        {/* LOYALTY RULES */}
        <Route
          path="/merchantrules"
          element={<MerchantLoyaltyRules />}
        />

        {/* ANALYTICS + FEEDBACK */}
        <Route
          path="/merchantanalytics"
          element={<MerchantFeedbackLog />}
        />



        {/* =========================
            INVALID ROUTE REDIRECT
        ========================= */}
        {/* 
        <Route
          path="*"
          element={<Navigate to="/" />}
        /> */}

      </Routes>

    </BrowserRouter>

  );

}

export default App;